import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import { connect } from 'react-redux';
import { userInfoSelector } from 'selectors/app-selector';
import { getUserCountryCode } from 'helper/user';
import css from './footer.less';

const Footer = props => {
  const { userInfo } = props;
  const countryCode = userInfo ? getUserCountryCode(userInfo) : null;

  // display terms & conditions / privacy footer
  return countryCode && countryCode.toLowerCase() === 'vn' ? (
    <div className={css.container}>
      <div className={css.text}>
        <a
          href="https://www.grab.com/vn/terms-policies/transport-delivery-logistics/"
          target="_blank"
          rel="noopener noreferrer"
        >
          {I18n.t('v2.vietnamFooter.termsAndConditions')}
        </a>
        <span>•</span>
        <a
          href="https://www.grab.com/vn/terms-policies/privacy-notice/"
          target="_blank"
          rel="noopener noreferrer"
        >
          {I18n.t('v2.vietnamFooter.privacy')}
        </a>
      </div>
    </div>
  ) : null;
};

Footer.propTypes = {
  userInfo: PropTypes.shape({}).isRequired,
};

export const mapStateToProps = state => ({
  userInfo: userInfoSelector(state),
});

export default connect(mapStateToProps)(Footer);
